import { Component, Input, Output, EventEmitter, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SettingService } from '../../../../Utils/_services/admin/settings/settings.service';


@Component({
  selector: 'app-view-subscription-plan-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './view-subscription-plan-modal.component.html',
  styleUrl: './view-subscription-plan-modal.component.css',
})
export class ViewSubscriptionPlanModalComponent implements OnInit {
  @Input() visible = false;
  @Input() plan: any = null;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSave = new EventEmitter<void>();

  isEditing = false;
  isSaving = false;
  editLimits: any = {
    dailySwipes: 0,
    dailyPops: 0,
    dailySuperLikes: 0,
    dailyRewinds: 0
  };

  private settingService = inject(SettingService);

  ngOnInit(): void { }

  startEdit(): void {
    if (this.plan && this.plan.limits) {
      this.editLimits = {
        dailySwipes: this.plan.limits.dailySwipes || 0,
        dailyPops: this.plan.limits.dailyPops || 0,
        dailySuperLikes: this.plan.limits.dailySuperLikes || 0,
        dailyRewinds: this.plan.limits.dailyRewinds || 0
      };
      this.isEditing = true;
    }
  }

  cancelEdit(): void {
    this.isEditing = false;
  }

  saveEdit(): void {
    if (!this.plan?._id) return;
    this.isSaving = true;

    const payload = {
      planId: this.plan._id,
      limits: {
        dailySwipes: this.editLimits.dailySwipes,
        dailyPops: this.editLimits.dailyPops,
        dailySuperLikes: this.editLimits.dailySuperLikes,
        dailyRewinds: this.editLimits.dailyRewinds
      }
    };

    this.settingService.updateSubscriptionPlan(payload).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        this.isEditing = false;
        if (res && res.data && res.data.plan) {
          this.plan.limits = res.data.plan.limits;
        }
        this.onSave.emit();
      },
      error: (err: any) => {
        this.isSaving = false;
        console.error('Failed to update subscription plan limits:', err);
      }
    });
  }

  close(): void {
    this.isEditing = false;
    this.onClose.emit();
  }
}
